export const ApiEntityUnitCategories = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const load = async (id, module = 'accommodations') => {
    const result = await axios.get(`/api/entities/${module}/${id}/units/categories`)
    return result.data
  }

  const save = async (id, payload, module = 'accommodations') => {
    const result = await axios.post(`/api/entities/${module}/${id}/units/categories/${payload.category.id}`, payload)
    return result.data
  }

  const remove = async (id, payload, module = 'accommodations') => {
    const result = await axios.delete(`/api/entities/${module}/${id}/units/categories/${payload.category.id}`)
    return result.data
  }

  const find = async (id, aid, module = 'accommodations') => {
    const result = await axios.get(`/api/entities/${module}/${aid}/units/categories/${id}`)
    return result.data
  }

  return {
    entityUnitCategoriesFind: find,
    entityUnitCategoriesLoad: load,
    entityUnitCategoriesSave: save,
    entityUnitCategoriesRemove: remove
  }
}
